import React from "react";
import UpcomingAuctionsTable from "./UpcomingAuctionsTable";

import "./index.css";
import DashboardSectionWrapper from "../components/DashboardSectionWrapper";

const UpcomingAuctions = () => {
  return (
    <DashboardSectionWrapper title="My Upcoming Auctions">
      <UpcomingAuctionsTable />
    </DashboardSectionWrapper>
  );
};

export default UpcomingAuctions;
